import * as React from 'react';

interface Props {
  fileName: string;
}

const ContractSignedComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div>
    <div className="gap-50"/>
    <span className="corrected-small-circle"/>
    <div className="gap-20"/>
    <p className="text-center">
      <strong>
        Has aceptado el
      </strong>
    </p>
    <p className="text-center">
      <strong>{props.fileName}</strong>
    </p>
    <div className="gap-20"/>
  </div>
);

export default ContractSignedComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/sign-contracts/partials/ContractSigned.component.tsx